"use client";
import CustomCarousel from "@/components/CustomCarousel/CustomCarousel.js";
import { wellnessTreatmentCarousel } from "@/utils/data";
import "./aestheticTreatments.scss";
import Image from "next/image";
import Benefits from "@/components/Benefits/Benefits";
import HospitalCarousel from "@/components/HospitalsCarousel/HosptalsCarousel";
import DoctorsCarousel from "@/components/DoctorsCarousel/DoctorsCarousel";
import Treatments from "@/components/Treatments/Treatments";
import Link from "next/link";
import { routeName } from "@/utils/commonfuntions";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";

export default function AestheticTreatments() {
  let allBenefits = [
    {
      benefitsFor: "The Skin & Hair",
      imgSrc: "/images/skinHair.webp",
      features: [
        { heading: "Improves", subHeading: "skin texture" },
        { heading: "Reduces", subHeading: "fine lines and wrinkles" },
        { heading: "Fights", subHeading: "Hyperpigmentation" },
        { heading: "Tightens", subHeading: "Skin" },
        { heading: "Reduces", subHeading: "pore size" },
        { heading: "Increases", subHeading: "skin hydration" },
        { heading: "Increases", subHeading: "hair growth" },
        { heading: "Reduces", subHeading: "hair loss and thinning" },
        { heading: "Strengthens", subHeading: "hair follicles" },
        { heading: "Enhances", subHeading: "blood circulation" },
      ],
    },
    {
      benefitsFor: "Body Function",
      imgSrc: "/images/bodyAesthetic.webp",
      features: [
        { heading: "Reduces", subHeading: "Fat" },
        { heading: "Tightens", subHeading: "Skin" },
        { heading: "Diminishes", subHeading: "stretch marks" },
        { heading: "Skin", subHeading: "rejuvenation" },
        { heading: "Improves", subHeading: "body confidence" },
        {
          heading: "Reduces",
          subHeading: "excess skin after weight loss",
        },
        { heading: "Reduces", subHeading: "lymphatic drainage" },
        { heading: "Minimizes", subHeading: "surgical scars" },
      ],
    },
    {
      benefitsFor: "Makeup Solution",
      imgSrc: "/images/makeup.webp",
      features: [
        { heading: "Improves", subHeading: "facial proportions" },
        { heading: "Lifts", subHeading: "sagging skin" },
        { heading: "Boosts", subHeading: "Immune System" },
        { heading: "Balances", subHeading: "facial symmetry" },
        { heading: "Softens", subHeading: "deep facial folds" },
        { heading: "Reshapes", subHeading: "nose and jawline" },
        { heading: "Enhances", subHeading: "cheeks and lips" },
        { heading: "Eliminates", subHeading: "under eye dark circles" },
        { heading: "Reduces", subHeading: "puffiness" },
        { heading: "Resurfacing", subHeading: "dull skin" },
      ],
    },
  ];

  return (
    <div>
      <BreadCrumbs />
      <div className="aestheticTreatmentsWrapper">
        <CustomCarousel itemsPerPage={4}>
          {wellnessTreatmentCarousel.map((treatment, i) => {
            return (
              <div key={i} className="treatmentContainer">
                <div className="treatmentImgContainer">
                  <Image
                    loading="lazy"
                    src={treatment.img}
                    alt="treatment image"
                    fill
                    layout=""
                    style={{ objectFit: "cover" }}
                  />
                </div>
                <Link
                  href={{
                    pathname: `/aesthetictreatments/${routeName(
                      treatment.name,
                    )}`,
                  }}
                  className="treatmentBtn"
                >
                  <p className="m-auto">{treatment.name}</p>
                  <Image
                    loading="lazy"
                    src="/images/arrowRight1.svg"
                    alt="arrow right"
                    width={13}
                    height={11}
                  />
                </Link>
              </div>
            );
          })}
        </CustomCarousel>
      </div>
      <Benefits allBenefits={allBenefits} />
      <HospitalCarousel itemsPerPage={4} />
      <DoctorsCarousel itemsPerPage={4} />
      <Treatments numOfRows={1} />
    </div>
  );
}
